module.exports = __webpack_public_path__ + "static/media/Hombre1.69a785e1.svg";